import { LIST_MEMBERSHIP_OBJECTS } from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { List } from 'immutable';
import Adapter from './Adapter';
import HttpAdapterConfig from '../adapterConfigs/HttpAdapterConfig';
import { getMetadataValue } from '../../../utils/frameworkBuilder';
import { resolveHasScope } from '../../../utils/UserInfoHelper';
export class ListsMembershipObjectsAdapterConfig extends HttpAdapterConfig {
  constructor(...args) {
    super(...args);
    this.performanceTrackingKey = 'ListsMembershipObjectsAdapter';
  }
  getCacheKey() {
    return 'LISTS_MEMBERSHIP_OBJECTS';
  }
  isAssetFamilySupported(assetFamily) {
    return assetFamily === LIST_MEMBERSHIP_OBJECTS;
  }
  fetchData(httpClient) {
    return httpClient('framework-builder/v1/read/metadata/types/crmSegmentsUI', {
      query: {
        transformGateValues: true
      }
    });
  }
  formatData(response) {
    const enabledListMembershipObjects = Object.values(response).filter(({
      metadata
    }) => {
      const enabled = getMetadataValue(metadata.enabled);
      const objectTypeId = getMetadataValue(metadata.objectTypeId);
      const scope = getMetadataValue(metadata.scope);
      const gate = getMetadataValue(metadata.gate);
      const isUngated = gate !== null && gate !== void 0 ? gate : true;
      const hasScope = scope ? resolveHasScope()(scope) : true;
      return Boolean(enabled && objectTypeId && isUngated && hasScope);
    }).map(({
      metadata
    }) => {
      const {
        objectTypeId
      } = metadata;
      // can assert that objectTypeId is not undefined because of the filter above
      return getMetadataValue(objectTypeId);
    });
    return List(enabledListMembershipObjects);
  }
}
export default Adapter.makeFromConfig(ListsMembershipObjectsAdapterConfig);